<template>
  <section id="contact">
    <div class="section padding-page-top padding-bottom over-hide">
      <div class="container">
        <div class="row page-title px-4 px-xl-2">
          <div class="col-12 parallax-fade-top">
            <h1>Say Hello</h1>
          </div>
          <div class="offset-1 col-11 parallax-fade-top mt-2 mt-sm-3">
            <p>get in touch</p>
          </div>
        </div>
      </div>
    </div>
    <ContactForm />
    <ContactMap />
  </section>
</template>

<script>
import ContactForm from "@/components/ContactForm";
import ContactMap from "@/components/ContactMap";
import { ParallaxEffect } from "@/components/utils";

import { EventBus } from "../main";
export default {
  components: {
    ContactForm,
    ContactMap
  },
  mounted() {
    EventBus.$emit(
      "allLinks",
      document.querySelectorAll(
        "a, input, textarea, select, button,  .vs__actions, .vs__selected-options, .submitting small"
      )
    );

    ParallaxEffect(this.$el);
  }
};
</script>

<style lang="scss" scoped></style>
